import type { ModelState } from '@/features/domaine/types/techniques'

export enum PropertyStatus {
  NotPresent = -1,
  Optional = 0,
  Required = 1,
}

//export const $status = '$propertStatus'
export type CheckedPropertyStatus = { $status?: PropertyStatus }

export type Status<T extends object> = ModelState<T, CheckedPropertyStatus>
